// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/result_media_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ResultMedia } from "../../entity/result_pb";

/**
 * UploadResultMediaArgs メッセージ
 *
 * @generated from message service.UploadResultMediaArgs
 */
export class UploadResultMediaArgs extends Message<UploadResultMediaArgs> {
  /**
   * @generated from field: bytes file_data = 1 [json_name = "file_data"];
   */
  fileData = new Uint8Array(0);

  /**
   * @generated from field: string file_name = 2 [json_name = "file_name"];
   */
  fileName = "";

  /**
   * @generated from field: string content_type = 3 [json_name = "content_type"];
   */
  contentType = "";

  /**
   * @generated from field: string result_id = 4 [json_name = "result_id"];
   */
  resultId = "";

  /**
   * @generated from field: string media_type = 5 [json_name = "media_type"];
   */
  mediaType = "";

  /**
   * @generated from field: string caption = 6;
   */
  caption = "";

  constructor(data?: PartialMessage<UploadResultMediaArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UploadResultMediaArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_data", jsonName: "file_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "file_name", jsonName: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_type", jsonName: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "result_id", jsonName: "result_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "media_type", jsonName: "media_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadResultMediaArgs {
    return new UploadResultMediaArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadResultMediaArgs {
    return new UploadResultMediaArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadResultMediaArgs {
    return new UploadResultMediaArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UploadResultMediaArgs | PlainMessage<UploadResultMediaArgs> | undefined, b: UploadResultMediaArgs | PlainMessage<UploadResultMediaArgs> | undefined): boolean {
    return proto3.util.equals(UploadResultMediaArgs, a, b);
  }
}

/**
 * DeleteResultMediaArgs メッセージ
 *
 * @generated from message service.DeleteResultMediaArgs
 */
export class DeleteResultMediaArgs extends Message<DeleteResultMediaArgs> {
  /**
   * @generated from field: string storage_path = 1 [json_name = "storage_path"];
   */
  storagePath = "";

  constructor(data?: PartialMessage<DeleteResultMediaArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteResultMediaArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "storage_path", jsonName: "storage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteResultMediaArgs {
    return new DeleteResultMediaArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteResultMediaArgs {
    return new DeleteResultMediaArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteResultMediaArgs {
    return new DeleteResultMediaArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteResultMediaArgs | PlainMessage<DeleteResultMediaArgs> | undefined, b: DeleteResultMediaArgs | PlainMessage<DeleteResultMediaArgs> | undefined): boolean {
    return proto3.util.equals(DeleteResultMediaArgs, a, b);
  }
}

/**
 * UploadResultCategoryThumbnailArgs メッセージ
 *
 * @generated from message service.UploadResultCategoryThumbnailArgs
 */
export class UploadResultCategoryThumbnailArgs extends Message<UploadResultCategoryThumbnailArgs> {
  /**
   * @generated from field: string category_id = 1 [json_name = "category_id"];
   */
  categoryId = "";

  /**
   * @generated from field: string file_name = 2 [json_name = "file_name"];
   */
  fileName = "";

  /**
   * @generated from field: string content_type = 3 [json_name = "content_type"];
   */
  contentType = "";

  /**
   * @generated from field: bytes file_data = 4 [json_name = "file_data"];
   */
  fileData = new Uint8Array(0);

  constructor(data?: PartialMessage<UploadResultCategoryThumbnailArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UploadResultCategoryThumbnailArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category_id", jsonName: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", jsonName: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_type", jsonName: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "file_data", jsonName: "file_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadResultCategoryThumbnailArgs {
    return new UploadResultCategoryThumbnailArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadResultCategoryThumbnailArgs {
    return new UploadResultCategoryThumbnailArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadResultCategoryThumbnailArgs {
    return new UploadResultCategoryThumbnailArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UploadResultCategoryThumbnailArgs | PlainMessage<UploadResultCategoryThumbnailArgs> | undefined, b: UploadResultCategoryThumbnailArgs | PlainMessage<UploadResultCategoryThumbnailArgs> | undefined): boolean {
    return proto3.util.equals(UploadResultCategoryThumbnailArgs, a, b);
  }
}

/**
 * UploadResultMediaReply メッセージ
 *
 * @generated from message service.UploadResultMediaReply
 */
export class UploadResultMediaReply extends Message<UploadResultMediaReply> {
  /**
   * @generated from field: entity.ResultMedia media = 1;
   */
  media?: ResultMedia;

  constructor(data?: PartialMessage<UploadResultMediaReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UploadResultMediaReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "media", kind: "message", T: ResultMedia },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadResultMediaReply {
    return new UploadResultMediaReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadResultMediaReply {
    return new UploadResultMediaReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadResultMediaReply {
    return new UploadResultMediaReply().fromJsonString(jsonString, options);
  }

  static equals(a: UploadResultMediaReply | PlainMessage<UploadResultMediaReply> | undefined, b: UploadResultMediaReply | PlainMessage<UploadResultMediaReply> | undefined): boolean {
    return proto3.util.equals(UploadResultMediaReply, a, b);
  }
}

/**
 * DeleteResultMediaReply メッセージ
 *
 * @generated from message service.DeleteResultMediaReply
 */
export class DeleteResultMediaReply extends Message<DeleteResultMediaReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<DeleteResultMediaReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteResultMediaReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteResultMediaReply {
    return new DeleteResultMediaReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteResultMediaReply {
    return new DeleteResultMediaReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteResultMediaReply {
    return new DeleteResultMediaReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteResultMediaReply | PlainMessage<DeleteResultMediaReply> | undefined, b: DeleteResultMediaReply | PlainMessage<DeleteResultMediaReply> | undefined): boolean {
    return proto3.util.equals(DeleteResultMediaReply, a, b);
  }
}

/**
 * UploadResultCategoryThumbnailReply メッセージ
 *
 * @generated from message service.UploadResultCategoryThumbnailReply
 */
export class UploadResultCategoryThumbnailReply extends Message<UploadResultCategoryThumbnailReply> {
  /**
   * @generated from field: string storage_path = 1 [json_name = "storage_path"];
   */
  storagePath = "";

  constructor(data?: PartialMessage<UploadResultCategoryThumbnailReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UploadResultCategoryThumbnailReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "storage_path", jsonName: "storage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadResultCategoryThumbnailReply {
    return new UploadResultCategoryThumbnailReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadResultCategoryThumbnailReply {
    return new UploadResultCategoryThumbnailReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadResultCategoryThumbnailReply {
    return new UploadResultCategoryThumbnailReply().fromJsonString(jsonString, options);
  }

  static equals(a: UploadResultCategoryThumbnailReply | PlainMessage<UploadResultCategoryThumbnailReply> | undefined, b: UploadResultCategoryThumbnailReply | PlainMessage<UploadResultCategoryThumbnailReply> | undefined): boolean {
    return proto3.util.equals(UploadResultCategoryThumbnailReply, a, b);
  }
}

